import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[#111111] text-white border-t border-[#2a2a2a] py-8">
      <div className="max-w-6xl mx-auto px-4 grid md:grid-cols-3 gap-8 items-center">
        {/* Left: Brand Info */}
        <div>
          <h3 className="text-xl font-semibold text-[#C6A564]">SeguraTech</h3>
          <p className="text-sm text-white/70">
            Security, Reliability & Integrity Delivered.
          </p>
        </div>

        {/* Middle: Links */}
        <div className="flex justify-center gap-8 text-sm">
          <Link to="/" className="hover:text-[#C6A564] transition">
            Home
          </Link>
          <Link to="/about" className="hover:text-[#C6A564] transition">
            About
          </Link>
          <Link to="/services" className="hover:text-[#C6A564] transition">
            Services
          </Link>
          <Link to="/policies" className="hover:text-[#C6A564] transition">
            Policies
          </Link>
          <Link to="/contact" className="hover:text-[#C6A564] transition">
            Contact
          </Link>
        </div>

        {/* Right: Contact Info */}
        <div className="text-center md:text-right text-sm">
          <p className="text-white/80">📞 07494 184775</p>
          <p className="text-white/80">✉️ info@seguratech.co.uk</p>
          <p className="text-white/60">Worthing, Sussex</p>
        </div>
      </div>

      {/* Bottom Line */}
      <div className="text-center text-xs text-white/50 mt-6">
        © {new Date().getFullYear()} SeguraTech. All rights reserved.
      </div>
    </footer>
  );
}
